import type { RootState } from '@/store/store'
import { AgentV2TransportPhase, type AgentV2TransportEntry } from './slice'

const kIdleAgentV2TransportEntry: AgentV2TransportEntry = {
  clientRequestId: null,
  phase: AgentV2TransportPhase.IDLE,
  stopSent: false,
}

export const selectAgentV2TransportEntry = (state: RootState, props: { conversationId: string | undefined }) =>
  state.agentV2TransportState.byConversationId[props.conversationId ?? ''] ?? kIdleAgentV2TransportEntry

export const selectAgentV2TransportPhase = (state: RootState, props: { conversationId: string | undefined }) => selectAgentV2TransportEntry(state, props).phase

export const selectAgentV2TransportCanStopOrAbort = (state: RootState, props: { conversationId: string | undefined }) => {
  const phase = selectAgentV2TransportPhase(state, props)
  return phase === AgentV2TransportPhase.CONNECTING || phase === AgentV2TransportPhase.OPEN
}

export const selectAgentV2TransportIsDetached = (state: RootState, props: { conversationId: string | undefined }) =>
  selectAgentV2TransportPhase(state, props) === AgentV2TransportPhase.DETACHED
